<template>
  <div class="content if-profile manual_input report-tab">
    <div class="md-layout ratios-report">
      <IFReportHeader :headerData="this.headerData" />

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
      >
        <div class="manege-input-popap">
          <!-- <md-dialog :md-active.sync="showDialog">
            <p>
              <b
                >Net Working Capital (Current Assets-Current
                Liabilities)/Business Revenue.</b
              >
              Indicates if a company is maintaining a reasonable level of
              liquidity relative to its Business Revenue volume. Higher is
              generally better, but very high ratios may indicate an overly
              conservative reliance on liquid assets, while low ratios suggest
              the opposite. Your score suggests that the business should
              undertake a significant review of liquidity practices.
            </p>
          </md-dialog>-->
          <!-- <md-card-header class="md-card-header-icon messages-box">
            <div class="card-icon md-ripple" @click="showDialog = true">
              <md-icon class="icon-arrow">double_arrow</md-icon>
              <md-icon>help</md-icon>
            </div>
          </md-card-header>-->
        </div>
        <div class="md-toolbar-row">
          <nav-tabs-card>
            <template slot="content">
              <!-- <md-card-header class="md-card-header-icon manag-title">
                <h1 class="md-headline text-left">
                  Manage Inputs
                </h1>
              </md-card-header>-->
              <h1 v-if="!isSample" class="section_header m-0 p-0">
                Manage Inputs
              </h1>
              <div v-if="!isSample" class="md-layout-item md-size-100 p-0">
                <md-card class="if_card">
                  <md-card-header class="md-card-header-icon"
                    >Data Input Upload</md-card-header
                  >
                  <md-card-content>
                    <div class="extra_space">
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 p-0"
                        >
                          <!-- <h3>Data Input Upload</h3> -->
                          <ul>
                            <li>
                              Download the Bizminer Industry Financial Input
                              5-year Templateand save it offline as a CSV file.
                            </li>
                            <li>Populate the template offline</li>
                            <li>
                              Select the Choose File or Browse button to find
                              the populated CSV file on your device.
                            </li>
                            <li>
                              Use the Upload Inputs button to complete the
                              process.
                            </li>
                            <li>
                              Generate the report. Your financials will be
                              integrated; percentages, summary line items and
                              ratios will auto-calculate.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="md-layout">
                        <div class="md-layout-item p-0">
                          <upload-my-data></upload-my-data>
                        </div>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <div class="md-layout">
                <div
                  class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 py-4"
                >
                  <h1 class="section_header p-0 my-2">Manual Input</h1>
                  <h5 class="m-0">
                    <strong>
                      *Please do not use periods, dollar signs, or character,
                      Commas are automatically added.
                    </strong>
                  </h5>
                  <h5 class="m-0">
                    <strong>
                      *Business Revenue and Gross Margin are required fields
                    </strong>
                  </h5>
                </div>
                <div
                  class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 p-0 mt-2"
                >
                  <md-tabs md-alignment="left">
                    <md-tab
                      v-for="input in newInputFields"
                      :id="input.title"
                      :key="input.title"
                      :md-label="input.title"
                      md-icon="arrow_drop_down"
                      class="p-0"
                    >
                      <div class="md-layout">
                        <div class="md-layout-item p-0">
                          <md-card-header>{{ input.title }}</md-card-header>
                          <md-card-content>
                            <md-table class="profit-and-loss-table">
                              <md-table-row>
                                <md-table-head
                                  :class="{
                                    'md-table-black-side-label':
                                      input.type !== 'BlueYears',
                                    'md-table-side-label':
                                      input.type === 'BlueYears',
                                  }"
                                  >{{ input.title }}</md-table-head
                                >
                                <md-table-head
                                  v-for="(key, index) in years"
                                  :key="key"
                                  :class="{
                                    grey:
                                      !showYears[index] &&
                                      input.type === 'BlueYears',
                                  }"
                                  class="md-table-side-label"
                                  >{{
                                    input.type === "BlueYears" ? key : ""
                                  }}</md-table-head
                                >
                                <!-- <md-table-head></md-table-head> -->
                              </md-table-row>

                              <md-table-row
                                v-for="field in input.data"
                                :key="field"
                              >
                                <md-table-cell :md-label="input.title">
                                  {{
                                    checkField(
                                      data[0]["array_BB"]["array_lookup_ALL"][
                                        field
                                      ]["title"]
                                    )
                                  }}
                                </md-table-cell>

                                <md-table-cell
                                  v-for="(each, index) in arrayTableModel"
                                  :key="index"
                                  :class="{ grey: !showYears[index] }"
                                >
                                  <input
                                    :id="
                                      data[0]['array_BB']['array_lookup_ALL'][
                                        field
                                      ]['input'] +
                                        '_' +
                                        index
                                    "
                                    v-model="
                                      each[
                                        data[0]['array_BB']['array_lookup_ALL'][
                                          field
                                        ]['input']
                                      ]
                                    "
                                    @input="
                                      (e) =>
                                        handleInput(
                                          e,
                                          data[0]['array_BB'][
                                            'array_lookup_ALL'
                                          ][field]['input'],
                                          index
                                        )
                                    "
                                  />
                                </md-table-cell>
                              </md-table-row>
                            </md-table>
                          </md-card-content>
                        </div>
                      </div>
                      <div
                        v-if="!isSample"
                        class="md-layout-item md-size-100 p-0 btn_wpr"
                      >
                        <button
                          type="button"
                          @click="saveReport('clear')"
                          class="md-button md-info md-theme-default button-inputs"
                        >
                          <div class="md-ripple">
                            <div class="md-button-content">Clear Inputs</div>
                          </div>
                        </button>
                        <button
                          v-if="!isSample"
                          type="button"
                          @click="saveReport()"
                          class="md-button md-info md-theme-default"
                        >
                          <div class="md-ripple">
                            <div class="md-button-content">
                              Submit Manual Inputs
                            </div>
                          </div>
                        </button>
                      </div>
                    </md-tab>
                  </md-tabs>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavTabsCard } from "@/components";
import { mapActions, mapState } from "vuex";
import IFReportHeader from "./_partials/IFHeader.vue";
import UploadMyData from "@/components/UploadMyData.vue";
//import UploadMyData from '@/components/UploadMyData.vue';

export default {
  components: {
    IFReportHeader,
    NavTabsCard,
    UploadMyData,
    // UploadMyData,
    // UploadMyData,
  },
  props: ["headerData"],
  data() {
    return {
      showDialog: false,
      newArrayValue: null,
      single: null,
      params: {},
      newInputFields: [],
      arrayTableModel: [],
      emptyArray: [
        {
          inputID: 0,
          ID: this.$route.params.id,
          year: "2019", // TODO: make this automatic.
          asset_cash: 0,
          asset_accountsReceivable: 0,
          asset_inventory: 0,
          asset_otherCurrent: 0,
          asset_gross_fixed: 0,
          asset_depreciation_amortization_depletion: 0,
          asset_fixed: 0,
          asset_otherNonCurrent: 0,
          liability_accountsPayable: 0,
          liability_loans: 0,
          liability_otherCurrent: 0,
          liability_longTermDebt: 0,
          liability_netWorth: 0,
          other_netSales: 0,
          cosl: 0,
          other_grossProfit: 0,
          other_netProfit: 0,
          other_workingCapital: 0,
          other_offcomp: 0,
          other_payroll: 0,
          other_rent: 0,
          other_taxes: 0,
          other_interest: 0,
          other_amortization: 0,
          other_advertising: 0,
          other_benefits: 0,
          other_other: 0,
          other_interestincome: 0,
          other_otherincome: 0,
          other_repairs: 0,
          other_baddebt: 0,
          other_cosl: 0,
          other_insurance: 0,
          other_homeoffice: 0,
          income_tax: 0,
          ft_emps: 0,
          avg_annual_wage: 0,
        },
        {
          inputID: 0,
          ID: this.$route.params.id,
          year: "2020", // TODO: make this automatic.
          asset_cash: 0,
          asset_accountsReceivable: 0,
          asset_inventory: 0,
          asset_otherCurrent: 0,
          asset_gross_fixed: 0,
          asset_depreciation_amortization_depletion: 0,
          asset_fixed: 0,
          asset_otherNonCurrent: 0,
          liability_accountsPayable: 0,
          liability_loans: 0,
          liability_otherCurrent: 0,
          liability_longTermDebt: 0,
          liability_netWorth: 0,
          other_netSales: 0,
          cosl: 0,
          other_grossProfit: 0,
          other_netProfit: 0,
          other_workingCapital: 0,
          other_offcomp: 0,
          other_payroll: 0,
          other_rent: 0,
          other_taxes: 0,
          other_interest: 0,
          other_amortization: 0,
          other_advertising: 0,
          other_benefits: 0,
          other_other: 0,
          other_interestincome: 0,
          other_otherincome: 0,
          other_repairs: 0,
          other_baddebt: 0,
          other_cosl: 0,
          other_insurance: 0,
          other_homeoffice: 0,
          income_tax: 0,
          ft_emps: 0,
          avg_annual_wage: 0,
        },
        {
          inputID: 0,
          ID: this.$route.params.id,
          year: "2021", // TODO: make this automatic.
          asset_cash: 0,
          asset_accountsReceivable: 0,
          asset_inventory: 0,
          asset_otherCurrent: 0,
          asset_gross_fixed: 0,
          asset_depreciation_amortization_depletion: 0,
          asset_fixed: 0,
          asset_otherNonCurrent: 0,
          liability_accountsPayable: 0,
          liability_loans: 0,
          liability_otherCurrent: 0,
          liability_longTermDebt: 0,
          liability_netWorth: 0,
          other_netSales: 0,
          cosl: 0,
          other_grossProfit: 0,
          other_netProfit: 0,
          other_workingCapital: 0,
          other_offcomp: 0,
          other_payroll: 0,
          other_rent: 0,
          other_taxes: 0,
          other_interest: 0,
          other_amortization: 0,
          other_advertising: 0,
          other_benefits: 0,
          other_other: 0,
          other_interestincome: 0,
          other_otherincome: 0,
          other_repairs: 0,
          other_baddebt: 0,
          other_cosl: 0,
          other_insurance: 0,
          other_homeoffice: 0,
          income_tax: 0,
          ft_emps: 0,
          avg_annual_wage: 0,
        },
        {
          inputID: 0,
          ID: this.$route.params.id,
          year: "2022", // TODO: make this automatic.
          asset_cash: 0,
          asset_accountsReceivable: 0,
          asset_inventory: 0,
          asset_otherCurrent: 0,
          asset_gross_fixed: 0,
          asset_depreciation_amortization_depletion: 0,
          asset_fixed: 0,
          asset_otherNonCurrent: 0,
          liability_accountsPayable: 0,
          liability_loans: 0,
          liability_otherCurrent: 0,
          liability_longTermDebt: 0,
          liability_netWorth: 0,
          other_netSales: 0,
          cosl: 0,
          other_grossProfit: 0,
          other_netProfit: 0,
          other_workingCapital: 0,
          other_offcomp: 0,
          other_payroll: 0,
          other_rent: 0,
          other_taxes: 0,
          other_interest: 0,
          other_amortization: 0,
          other_advertising: 0,
          other_benefits: 0,
          other_other: 0,
          other_interestincome: 0,
          other_otherincome: 0,
          other_repairs: 0,
          other_baddebt: 0,
          other_cosl: 0,
          other_insurance: 0,
          other_homeoffice: 0,
          income_tax: 0,
          ft_emps: 0,
          avg_annual_wage: 0,
        },
      ],
    };
  },
  mounted() {
    this.getNewInputFields();

    if (Object.keys(this.valuesArr).length != 0)
      this.formatValuesArr(this.valuesArr);
    else this.formatValuesArr(this.emptyArray);
  },
  computed: {
    ...mapState({
      inputFields: (state) => state.user.report.inputFields,
      inputData: (state) =>
        state.user.report.inputData.length > 0
          ? state.user.report.inputData.map((e) => {
              return e;
            })
          : state.user.report.inputData,
      data: (state) =>
        state.user.report.data.length > 0
          ? state.user.report.data.map((e) => {
              return e;
            })
          : state.user.report.data,
      years: (state) =>
        state.user.report.years.map((item) => {
          return item;
        }),
      showYears: (state) => state.user.report.showYears,
    }),
    valuesArr() {
      return this.inputData;
    },
    isSample() {
      return this.$route.path.indexOf("sample") > -1;
    },
  },
  methods: {
    ...mapActions({
      save: "user/saveReport",
      getReport: "user/getReport",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    checkField(field) {
      if (field == "Business Revenue" || field == "Gross Margin")
        return field + " *";

      return field;
    },
    getNewInputFields() {
      let assets = null;
      let liabilities = null;
      this.inputFields.forEach((element) => {
        if (element.title === "Assets") {
          assets = element;
        } else if (element.title === "Liabilities") {
          liabilities = element;
        } else if (element.title !== "Balance Sheet") {
          this.newInputFields.push(element);
        }
      });
      let balance = {
        data: assets.data.concat(liabilities.data),
        title: "Balance Sheet",
        type: "BlueYears",
      };

      this.newInputFields.splice(1, 0, balance);
    },
    handleInput(e, key, index) {
      this.params[key + "_field_" + index] = Number(e.target.value);
    },
    saveReport(action = "save") {
      this.loading = true;
      let paramsData = {};

      if (action === "save") {
        let currentData = this.arrayTableModel.reduce(
          (acc, item, index) => ({
            ...acc,
            ...Object.entries(_.omit(item, ["ID", "inputID"])).reduce(
              (acc, [key, val]) => ({
                ...acc,
                [key + "_field_" + index]: parseInt(val),
              }),
              {}
            ),
          }),
          {}
        );

        let checkedYears = this.showYears.reduce((acc, v, i) => {
          if (v) return { ...acc, [`year_${i}_check`]: v };
          else return { ...acc };
        }, {});
        this.arrayTableModel.forEach(function(item, index, array) {
          let v = document.getElementById("other_netSales_" + index);
          if (
            (!item["other_netSales"] && item["year"] !== "2017") ||
            (parseInt(item["other_netSales"]) <= 0 && item["year"] !== "2017")
          ) {
            if (v) {
              v.classList.add("error-input");
            }
          } else {
            if (v.classList.contains("error-input")) {
              v.classList.remove("error-input");
            }
          }

          let c = document.getElementById("other_grossProfit_" + index);
          if (
            (!item["other_grossProfit"] && item["year"] !== "2017") ||
            (parseInt(item["other_grossProfit"]) <= 0 &&
              item["year"] !== "2017")
          ) {
            if (c) {
              c.classList.add("error-input");
            }
          } else {
            if (c.classList.contains("error-input")) {
              c.classList.remove("error-input");
            }
          }
        });
        let checkBoxData = {
          accounts_payable_business_revenue_check: true,
          ebitda_business_revenue_check: true,
          current_ratio_check: true,
          return_on_assets_check: true,
          quick_ratio_check: true,
          return_on_net_worth_check: true,
          days_payable_check: true,
          return_on_business_revenue_check: true,
          current_liabilities_inventory_check: true,
          discretionary_owner_earnings_check: true,
          net_working_capital_check: true,
          return_on_assets_after_tax_check: true,
          cosPayables_check: true,
          return_on_net_worth_after_tax_check: true,
          cosInventory_check: true,
          return_on_business_revenue_after_tax_check: true,
          profit_employee_check: true,
          owner_earnings_employee_check: true,
          assets_business_revenue_check: true,
          interest_coverage_check: true,
          days_inventory_check: true,
          current_liabilities_net_worth_check: true,
          days_receivables_check: true,
          long_term_liabilities_net_worth_check: true,
          current_asset_turnover_check: true,
          loans_notes_payable_net_worth_check: true,
          fixed_asset_turnover_check: true,
          zscore_check: true,
          gross_margin_business_revenue_check: true,
          total_liabilities_net_worth_check: true,
          sales_per_employee_check: true,
          fixedAssetsNetWorth_check: true,
          invTurnover_check: true,
          arTurnover_check: true,
          totalAssetTurnover_check: true,
          workingCapitalTurnover_check: true,
          daysWorkingCapital_check: true,
          cashTurnover_check: true,
          efficiency_index_check: true,
          year_0_check: true,
          year_1_check: true,
          year_2_check: true,
          year_3_check: true,
          year_4_check: true,
          year_5_check: true,
          pl_balance_percent_check: true,
          pl_balance_dollar_check: true,
          source_uses_check: true,
          ratio_scores_check: true,
          summary_scores_check: true,
        };

        paramsData.data = {
          ...currentData,
          ...this.params,
          ...checkedYears,
          ...checkBoxData,
        };
        // params.data = Object.keys( params.data).map(i => Number(params.data[i]))
        //params.data = _.omitBy(params.data, _.isNil);
        paramsData = Object.assign({}, paramsData);
      }
      if (action == "save") {
        if (action === "save" && paramsData.data.year_field_5 === 2021) {
          paramsData.data.year_field_5 = "2021";
        }
        this.save({
          action: action,
          ...paramsData,
          profile_id: this.$route.params.id,
          report_id: this.$route.params.id,
          type: "if",
        })
          .then((res) => {
            this.alertSuccess("Data loaded.");

            this.$router.push({
              name: "IFAboutTheData",
              params: this.$route.params.id,
            });
            this.$router.go();
          })
          .catch((err) => {
            this.alertSuccess("Data loaded.");
          })
          .finally(() => {
            this.loading = false;
            this.updatePullTime({
              isFinishedDate: true,
              productId: this.$route.params.id,
            });
          });
      } else if (action == "clear") {
        this.save({
          action: action,
          ...paramsData,
          profile_id: this.$route.params.id,
          report_id: this.$route.params.id,
          type: "if",
        })
          .then((res) => {
            this.alertSuccess("Data loaded.");

            this.$router.push({
              name: "IFAboutTheData",
              params: this.$route.params.id,
            });
            this.$router.go();
          })
          .catch((err) => {
            this.alertSuccess("Data loaded.");
          })
          .finally(() => {
            this.loading = false;
            this.updatePullTime({
              isFinishedDate: true,
              productId: this.$route.params.id,
            });
          });
      } else {
        this.alertError("There are some fields that need to be filled.");
      }
    },
    getObjectByYear: function(value) {
      return Object.keys(this.arrayTableModel).find(
        (el) => this.arrayTableModel[el].year === value
      );
    },
    formatValuesArr: function(newArr) {
      let firstElem = newArr[Object.keys(newArr)[0]];

      let keys = Object.keys(firstElem);

      let newArrayValue = [];

      for (let i = 0; i < this.years.length; i++) {
        var currentYear = this.years[i].replace("q2", "");
        let year = {};

        Object.keys(keys).forEach(function(key) {
          if (keys[key] === "year") year[keys[key]] = currentYear;
          else year[keys[key]] = 0;
        });
        newArrayValue.push(year);
      }

      var valuesArr = newArr;

      this.arrayTableModel = newArrayValue.map(
        function(element) {
          let findYear =
            element.year == 2021 && !this.$route.path.includes("dev")
              ? "2021"
              : element.year;
          let arrIndex = Object.keys(valuesArr).find(
            (el) => valuesArr[el].year === findYear
          );
          if (arrIndex) {
            return valuesArr[arrIndex];
          }

          return element;
        }.bind(this)
      );
    },
  },
};
</script>

<style lang="scss">
.ratios-report {
  .grey {
    /*background-color: black;*/
    /*opacity: 0.5;*/
    background-color: #c1c1c1;
  }

  .md-table-black-side-label {
    .md-table-head-label {
      color: black !important;
    }
  }

  .md-table-side-label {
    .md-table-head-label {
      color: #3b7ef1 !important;
    }
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }

  .choose-files-box {
    display: flex;
    align-items: center;
    margin-bottom: 25px;

    p {
      margin: 0;
      margin-left: 10px;
    }

    .md-icon {
      display: none !important;
    }

    .choose-file {
      background-color: #e3e4e5;
      width: 120px;
      border-radius: 3px;
      padding: 0;
      margin: 0;

      label {
        margin-right: 11px;
        position: absolute;
        left: 24px;
        top: 11px;
      }

      input {
        margin: 0;
      }
    }

    .upload-file {
      background-color: #3b7ef1;

      label {
        color: white;
        top: 11px;
      }
    }

    .md-field:not(.md-disabled):after {
      background-color: transparent;
    }
  }

  .icon-arrow {
    transform: rotate(180deg) !important;
  }

  .md-table-cell {
    // width: 100%;

    .md-table-cell-container {
      input {
        background-color: transparent !important;
        border: 1px solid #ddd;
        width: 60px;

        &.error-input {
          background-color: #ffbbbb !important;
        }
      }
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .manag-title {
    h1 {
      margin: 0;
    }
  }

  .manege-input-popap {
    display: flex;
    justify-content: flex-end;
  }
}

.button-inputs {
  margin-right: 10px !important;
}
</style>
